import { defineMessages, IntlFormatters } from "react-intl";

const scaleMessages = defineMessages({
    biton: {
        id: "meta.scale.biton",
    },
    triton: {
        id: "meta.scale.triton",
    },
    trichord: {
        id: "meta.scale.trichord",
    },
    tetraton: {
        id: "meta.scale.tetraton",
    },
    tetrachord: {
        id: "meta.scale.tetrachord",
    },
    pentaton: {
        id: "meta.scale.pentaton",
    },
    pentachord: {
        id: "meta.scale.pentachord",
    },
    hexachord: {
        id: "meta.scale.hexachord",
    },
    ion: {
        id: "meta.scale.ion",
    },
    dór: {
        id: "meta.scale.dór",
    },
    fríg: {
        id: "meta.scale.fríg",
    },
    líd: {
        id: "meta.scale.líd",
    },
    mixolíd: {
        id: "meta.scale.mixolíd",
    },
    eol: {
        id: "meta.scale.eol",
    },
    "összhangzatos moll": {
        id: "meta.scale.összhangzatos moll",
    },
    "dallamos moll": {
        id: "meta.scale.dallamos moll",
    },
    lokriszi: {
        id: "meta.scale.lokriszi",
    },
    egészhangú: {
        id: "meta.scale.egészhangú",
    },
    akusztikus: {
        id: "meta.scale.akusztikus",
    },
    egyéb: {
        id: "meta.scale.egyéb",
    },
});

export const scales = (fm: IntlFormatters["formatMessage"]) => {
    return [
        { value: "biton", label: fm(scaleMessages["biton"]) },
        { value: "triton", label: fm(scaleMessages["triton"]) },
        { value: "trichord", label: fm(scaleMessages["trichord"]) },
        { value: "tetraton", label: fm(scaleMessages["tetraton"]) },
        { value: "tetrachord", label: fm(scaleMessages["tetrachord"]) },
        { value: "pentaton", label: fm(scaleMessages["pentaton"]) },
        { value: "pentachord", label: fm(scaleMessages["pentachord"]) },
        { value: "hexachord", label: fm(scaleMessages["hexachord"]) },
        { value: "ion", label: fm(scaleMessages["ion"]) },
        { value: "dór", label: fm(scaleMessages["dór"]) },
        { value: "fríg", label: fm(scaleMessages["fríg"]) },
        { value: "líd", label: fm(scaleMessages["líd"]) },
        { value: "mixolíd", label: fm(scaleMessages["mixolíd"]) },
        { value: "eol", label: fm(scaleMessages["eol"]) },
        { value: "összhangzatos moll", label: fm(scaleMessages["összhangzatos moll"]) },
        { value: "dallamos moll", label: fm(scaleMessages["dallamos moll"]) },
        { value: "lokriszi", label: fm(scaleMessages["lokriszi"]) },
        { value: "egészhangú", label: fm(scaleMessages["egészhangú"]) },
        { value: "akusztikus", label: fm(scaleMessages["akusztikus"]) },
        { value: "egyéb", label: fm(scaleMessages["egyéb"]) },
    ];
};
